window.addToCart = function(variantId, event) {
  const button = event.target;
  
  button.textContent = 'AGREGANDO...';
  button.disabled = true;
  
  // Verificar si el producto ya existe
  fetch('/cart.js')
    .then(r => r.json())
    .then(cartBefore => {
      const existingItem = cartBefore.items.find(item => item.variant_id == variantId);
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(response => response.json())
      .then(() => {
        // Hacer click en plus del producto específico para refrescar
        setTimeout(() => {
          fetch('/cart.js')
            .then(r => r.json())
            .then(data => {
              const itemIndex = data.items.findIndex(item => item.variant_id == variantId);
              if (itemIndex !== -1) {
                const specificPlusBtn = document.querySelector(`[data-line="${itemIndex + 1}"] .ajaxcart__qty--plus`);
                if (specificPlusBtn) {
                  specificPlusBtn.click();
                  
                  // Solo ajustar cantidad a 1 si era un producto NUEVO
                  if (!existingItem) {
                    setTimeout(() => {
                      fetch('/cart.js')
                        .then(r => r.json())
                        .then(updatedCart => {
                          const newItemIndex = updatedCart.items.findIndex(item => item.variant_id == variantId);
console.log('DEBUG - variantId:', variantId, 'newItemIndex:', newItemIndex, 'quantity:', updatedCart.items[newItemIndex]?.quantity);
if (newItemIndex !== -1 && updatedCart.items[newItemIndex].quantity > 1) {
                            const qtyInput = document.querySelector(`[data-line="${newItemIndex + 1}"] .ajaxcart__qty-num`);
                            console.log('DEBUG - Found quantity input:', !!qtyInput);
                            if (qtyInput) {
                              console.log('DEBUG - Setting quantity to 1');
                              qtyInput.value = '1';
                              qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                          }
                        });
                    }, 2000);
                  }
                }
              }
            });
        }, 500);
        
        button.textContent = 'AGREGAR AL CARRO';
        button.disabled = false;
      });
    })
    .catch(() => {
      button.textContent = 'ERROR';
      button.disabled = false;
    });
};

window.addToCartAndOpenDrawer = function(variantId) {
  // Verificar si el producto ya existe
  fetch('/cart.js')
    .then(r => r.json())
    .then(cartBefore => {
      const existingItem = cartBefore.items.find(item => item.variant_id == variantId);
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(response => response.json())
      .then(() => {
        // Hacer click en plus del producto específico para refrescar
        setTimeout(() => {
          fetch('/cart.js')
            .then(r => r.json())
            .then(data => {
              const itemIndex = data.items.findIndex(item => item.variant_id == variantId);
              if (itemIndex !== -1) {
                const specificPlusBtn = document.querySelector(`[data-line="${itemIndex + 1}"] .ajaxcart__qty--plus`);
                if (specificPlusBtn) {
                  specificPlusBtn.click();
                  
                  // Solo ajustar cantidad a 1 si era un producto NUEVO
                  if (!existingItem) {
                    setTimeout(() => {
                      fetch('/cart.js')
                        .then(r => r.json())
                        .then(updatedCart => {
                          const newItemIndex = updatedCart.items.findIndex(item => item.variant_id == variantId);
console.log('DEBUG2 - variantId:', variantId, 'newItemIndex:', newItemIndex, 'quantity:', updatedCart.items[newItemIndex]?.quantity);
if (newItemIndex !== -1 && updatedCart.items[newItemIndex].quantity > 1) {
                            const qtyInput = document.querySelector(`[data-line="${newItemIndex + 1}"] .ajaxcart__qty-num`);
                            console.log('DEBUG2 - Found quantity input:', !!qtyInput);
                            if (qtyInput) {
                              console.log('DEBUG2 - Setting quantity to 1');
                              qtyInput.value = '1';
                              qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                          }
                        });
                    }, 2000);
                  }
                }
              }
              
              // Abrir el drawer
              const cartBtn = document.querySelector('.site-header__cart-toggle') ||
                             document.querySelector('.js-drawer-open-right-link') || 
                             document.querySelector('[data-drawer-open="right"]') ||
                             document.querySelector('.cart-link');
              
              if (cartBtn) {
                cartBtn.click();
              } else {
                window.location.href = window.location.href + '?cart=open';
              }
            });
        }, 500);
      });
    })
    .catch(error => console.error('Error adding to cart:', error));
};

// Auto-open cart if URL parameter is present
if (window.location.search.includes('cart=open')) {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      const cartButton = document.querySelector('.site-header__cart-toggle');
      if (cartButton) cartButton.click();
    }, 500);
  });
}